var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgClose = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "menu-icon",
    clipPath: "url(#clip0_0_2977)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M3.57791 0.673571C2.76622 -0.136014 1.44804 -0.136014 0.636354 0.673571C-0.175334 1.48316 -0.175334 2.79792 0.636354 3.60751L9.55843 12.5L0.642847 21.399C-0.168841 22.2085 -0.168841 23.5233 0.642847 24.3329C1.45454 25.1425 2.77272 25.1425 3.58441 24.3329L12.5 15.4339L21.4221 24.3264C22.2338 25.136 23.5519 25.136 24.3636 24.3264C25.1753 23.5168 25.1753 22.2021 24.3636 21.3925L15.4415 12.5L24.3571 3.60103C25.1688 2.79145 25.1688 1.47668 24.3571 0.667095C23.5454 -0.14249 22.2273 -0.14249 21.4156 0.667095L12.5 9.56606L3.57791 0.673571Z",
    fill: "#850064"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_0_2977"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 25,
    height: 25,
    fill: "white"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgClose);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/close.8b19adbd56c4c7e4dd015e4a636b2b4b.svg";